import { createFileRoute, redirect } from '@tanstack/react-router';

import { fetch } from 'api/typedFetch';

import { localStorage } from 'helpers/localStorage';

import { type AuthObject } from 'hooks/useSourceAuth';

import { IndexView } from 'views/IndexView';

const authDisabled = true;

const itemIsAuthObj = (item: unknown): item is AuthObject => {
  const itemToCheck = item as AuthObject;

  return [
    typeof itemToCheck === 'object',
    itemToCheck.type !== undefined,
    typeof itemToCheck?.type === 'string',
    itemToCheck.type === 'source_app_auth',
  ].every(Boolean);
};

export const Route = createFileRoute('/_auth')({
  component: IndexView,
  beforeLoad: ({ location }) => {
    const user = localStorage.get('USER');
    const params = new URLSearchParams(location.search);

    const redirNotSet = params.get('redirect') === null;

    const onValidLoginRoute = /(auth-mobile|login|magic-link|register)/.test(location.pathname);

    if (user === undefined && redirNotSet && !onValidLoginRoute) {
      throw redirect({
        to: '/login/',
        search: {
          state: 'login',
          redirect: location.href.includes('login') ? undefined : location.href,
        },
      });
    }

    // TODO: There may be a better way or location to handle this, but I throught a completely separate route would be overkill.
    // Updates the user's training started date if it's not set for the source specifically.
    if (user !== undefined && user.trainingStarted === null) {
      const date = new Date();
      const dateString = date.toLocaleDateString('fr-CA');

      void fetch('UPDATE_USER', {
        method: 'GET',
        params: new URLSearchParams({ email: user.email, app_id: process.env.APP_ID, training_started: dateString }),
      });

      localStorage.set('USER', { ...user, trainingStarted: date });
    }

    if (user !== undefined && !authDisabled) {
      const userAuth = user.custom.find((item) => {
        try {
          return itemIsAuthObj(item);
        } catch (error) {
          console.error(error);
          return false;
        }
      }) as AuthObject | undefined;

      if (!userAuth) {
        const newAuthObj = {
          type: 'source_app_auth',
          date: Date.now(),
        };

        void fetch('UPDATE_USER', {
          method: 'GET',
          params: new URLSearchParams({
            email: user.email,
            app_id: '760',
            custom_10: JSON.stringify(newAuthObj),
          }),
        });

        const newUser = {
          ...user,
          custom: [...user.custom, newAuthObj],
        };

        localStorage.set('USER', newUser);
        return;
      }

      const authExpired = Date.now() - userAuth.date > 1000 * 60 * 60 * 24 * 30;

      if (authExpired && redirNotSet && !onValidLoginRoute) {
        throw redirect({
          to: '/auth/',
          search: {
            redirect: location.href,
          },
        });
      }

      if (!authExpired && location.pathname === '/') {
        throw redirect({
          to: params.get('redirect') ?? '/home/',
        });
      }
    }
  },
});
